/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { takeLatest, ForkEffect } from 'redux-saga/effects';
import ActionConstants from '../constants';
import workerSaga from './workerSaga';

// ------------------------------------
// Watchers
// ------------------------------------
export default function* webhookEventWatcher(): Generator<
  ForkEffect<never>,
  void,
  unknown
> {
  yield takeLatest(ActionConstants.GET_WEBHOOK_EVENT_LIST, workerSaga);
  yield takeLatest(
    ActionConstants.GET_WEBHOOK_EVENT_LIST_FOR_SUBSCRIPTION,
    workerSaga
  );
  yield takeLatest(ActionConstants.GET_SUBSCRIPTION_EVENT_LIST, workerSaga);
  yield takeLatest(ActionConstants.REGISTER_WEBHOOK_EVENT_LIST, workerSaga);
  yield takeLatest(ActionConstants.UNREGISTER_WEBHOOK_EVENT_LIST, workerSaga);
  yield takeLatest(
    ActionConstants.REGISTER_MERCHANT_ON_WEBHOOK_EVENT,
    workerSaga
  );
  yield takeLatest(
    ActionConstants.STATUS_OF_REGISTER_MERCHANT_ON_WEBHOOK_EVENT,
    workerSaga
  );
  yield takeLatest(
    ActionConstants.STATUS_OF_REGISTER_MERCHANT_ON_WEBHOOK_EVENT_FOR_SUBSCRIPTION,
    workerSaga
  );
}
